export var parsePrice = function (priceString) {
    if (priceString) {
        var cleanedString = priceString.replace(/[^0-9.,-]/g, "");
        var normalizedString = cleanedString.replace(/,/g, "");
        return parseFloat(normalizedString);
    }
    return 0;
};
export var formatNumberCustom = function (num) {
    var parts = num.toFixed(2).split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
};
export var formatToTwoDecimals = function (value) {
    if (!value)
        return "0.00";
    var cleanValue = value.replace(/,/g, "");
    var numberValue = parseFloat(cleanValue);
    if (isNaN(numberValue))
        return "0.00";
    return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(numberValue);
};
